import React, { useState, useEffect, useRef } from 'react';
import { PrimeReactProvider } from 'primereact/api';
import { BrowserRouter  as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import "primereact/resources/themes/lara-light-blue/theme.css";
import 'primereact/resources/primereact.min.css'; // core css
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import ComparatorStart from './pages/ComparatorStart';

import SearchCat1 from './pages/SearchCat1';
import SearchCat2 from './pages/SearchCat2';
import SearchCat3 from './pages/SearchCat3';

import ResultsCat1 from './ChatBot/results/ResultsCat1';
import ResultsLuce from './ChatBot/results/ResultsLuce';
import ResultsGas from './ChatBot/results/ResultsGas';
import ResultsLuceGas from './ChatBot/results/ResultsLuceGas';

import ChatBot from './ChatBot/ChatBot';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;


function App() {


  React.useEffect(()  => {
    document.body.classList.add('mz_main-bg-color');

    return () => {
        document.body.classList.remove('mz_main-bg-color');
    };
});

  const value = {
    locale1: 'it',
    locale: 'en',
};


const getBasename = () => {
  const basename = process.env.PUBLIC_URL || '/'
  console.log(`Calculated basename ${basename}`)
  return basename
};

  return (
    <PrimeReactProvider value={value}>
      <Router basename={getBasename()}>
      <div>
        <Routes>
            <Route path="/" element={<ChatBot urlBotImage={IMAGE_URL+ "/robot-lia.png"} />} />
            <Route path="/results1" element={<ResultsCat1 />} />
            <Route path="/resultsLuce" element={<ResultsLuce />} />
            <Route path="/resultsLuceGas" element={<ResultsLuceGas />} />
            <Route path="/resultsGas" element={<ResultsGas />} />
            
           
            <Route path="/search1" element={<SearchCat1 />} />
            <Route path="/search2" element={<SearchCat2 />} />
            <Route path="/search3" element={<SearchCat3 />} />
        </Routes>
      </div>
    </Router>
    
    </PrimeReactProvider>
  );
}

export default App;
